/**
 * @author William A. Livesley
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-11-12
 * @description Implementation of the GraphQL mutation to create a new media asset.
 * @filename create-media-asset
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to create a new media asset.
 *
 * @type {GraphQLTaggedNode}
 */
export const CREATE_MEDIA_ASSET_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation createMediaAssetMutation($input: CreateMediaAssetInput!) {
    createMediaAsset(input: $input) {
      clientMutationId
      hasErrors
      errors {
        id
        location
      }
      mediaAsset {
        id
        description
        files {
          id
        }
      }
    }
  }
`;
